<template>

  <MassiveAssign
    :initAssign="initAssign"
    @hideModal="hideModal()" 
    @created="created()" />

</template>

<script>
import MassiveAssign from '@/components/MassiveAssign/MassiveAssign'

export default {
  name: 'JobActionMassAssign',
  components: {
    MassiveAssign
  },
  data () {
    return {
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    candidates () {
      return this.$store.getters.getCandidateSelected
    },
    initAssign () {
      return {
        candidates: this.candidates
      }
    }
  },
  created () {
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    created () {
      this.hideModal()
      this.$store.dispatch('resetCandidateSelected')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobMassiveAction/JobMassiveActionAssign.vue